import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const EventMainSection = withConfig(theme => styled('div', { label: 'EventMainSection' })`
    background: ${theme.star.eventsGroupedFiltersColors.bgColorSecondary};
`);
